module.exports = __webpack_public_path__ + "img/example_4.0c05b2ed.png";